<template>
    <div class="d-flex align-center mx-2">

        <div class="ml-4 flex-grow-1">
            <div class="text-h5 font-weight-light">
                {{app}}
            </div>
        </div>

        <div v-if="isValidUrl(app)">
            <a @click.stop="() => {}" :href="`https://${app}`" target="_blank" style="text-decoration: none; width: 120px">
                <v-btn
                        v-if="isValidUrl(app)"
                        small
                        outlined
                        color="primary"
                        class="mx-2"
                >
                    Goto Site
                    <v-icon right>mdi-arrow-top-right</v-icon>
                </v-btn>
            </a>
        </div>

        <app-toolbar-date-selector :range="this.$store.state.ref.dashboard.selectedRange"></app-toolbar-date-selector>


        <v-tooltip left v-if="access.classification">
            <template v-slot:activator="{on}">
                <v-btn
                        color="primary"
                        class="mx-2"
                        small
                        icon
                        v-on="on"
                        @click="gotoApp(app)"
                >
                    <v-icon>mdi-cog</v-icon>
                </v-btn>
            </template>
            Settings
        </v-tooltip>

        <v-btn
                icon
                color="primary"
                class="mx-2"
                small
        >
            <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
        <v-btn
                icon
                color="primary"
                class="mx-2"
                small
                @click="$store.state.ref.appStats.showCardsSelection = true"
        >
            <v-icon>mdi-apps</v-icon>
        </v-btn>
    </div>
</template>

<script>
import {
    addDays,
    endOfDay, endOfMonth,
    endOfWeek,
    format, isMonday,
    isSameDay,
    isSameMonth,
    isSameYear,
    startOfDay, startOfMonth,
    startOfWeek,
    subDays, subMonths, subWeeks
} from "date-fns";
import AppEmployeeAdd from "@/components/Employees/AppEmployeeAdd";
import {mapActions, mapGetters} from "vuex";
import {isValidUrl} from "@/core/codeFunctions";
import AppToolbarDateSelector from "@/components/Shared/AppToolbarDateSelector.vue";

const calFmt = (date) => {
    try {
        return format(date, 'yyyy-MM-dd')
    } catch (e) {
        return null;
    }
}

export default {
    components: {AppToolbarDateSelector},
    props: {
        shown: Boolean,
    },
    data() {
        return {
            isValidUrl,

            showAddEmployee: false
        }
    },
    methods: {
        ...mapActions(['gotoEmployeeSettings', 'gotoDeviceSettings', 'gotoApp']),
    },
    computed: {
        ...mapGetters(['access']),

        app() {
            // console.log()
            return this.$store.state.ref.appStats.selectedApp;
        },
    },
}
</script>

<style scoped>

</style>